import { useParams } from 'react-router-dom';
import { createUseCurrentWorkspace } from '@tickitacka/shared';
import { useMyWorkspaces } from '../services/useWorkspaceQueries';
import { useWorkspaceStore } from './workspaceStore';

function useWorkspaceIdFromUrl() {
    const { id } = useParams<{ id: string }>();
    return id;
}

const useCurrentWorkspace = createUseCurrentWorkspace({
    useMyWorkspaces,
    useWorkspaceStore,
    useWorkspaceIdFromUrl,
});

export { useCurrentWorkspace };
export default useCurrentWorkspace;
